var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--dashboard layout--admin"},[_c('app-header',{attrs:{"fixed":""}}),_c('div',{staticClass:"layout__content",class:{ 'layout__content--fluid': _vm.fluid }},[_c('admin-nav'),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }